import { defineMessages, IntlShape } from "react-intl";

export enum SortField {
  NAME = "name",
  CREATED_AT = "createdAt",
  FILE_SIZE = "file.contentLength",
  OWNER = "user.fullName",
  UPDATED_AT = "updatedAt",
  TYPE = "extension",
}

const messages = defineMessages<SortField>({
  [SortField.CREATED_AT]: {
    id: "resources.list.sort.field.createdAt",
    defaultMessage: "Date Created",
    description: "Date Created field label",
  },
  [SortField.FILE_SIZE]: {
    id: "resources.list.sort.field.fileSize",
    defaultMessage: "File Size",
    description: "File Size field label",
  },
  [SortField.NAME]: {
    id: "resources.list.sort.field.name",
    defaultMessage: "File Name",
    description: "Alphabetical field label",
  },
  [SortField.OWNER]: {
    id: "resources.list.sort.field.owner",
    defaultMessage: "Owner",
    description: "Owner field label",
  },
  [SortField.TYPE]: {
    id: "resources.list.sort.field.fileType",
    defaultMessage: "File Type",
    description: "File Type field label",
  },
  [SortField.UPDATED_AT]: {
    id: "resources.list.sort.field.updatedAt",
    defaultMessage: "Date Modified",
    description: "Date Modified field label",
  },
});

export const getSortFieldDisplayName = (intl: IntlShape, sortField: SortField) =>
  intl.formatMessage(messages[sortField]);

export default getSortFieldDisplayName;
